import translations from "../../translations/menuSheet.json";
import "../../styles/components/menuSheet/menuSheetWeb.scss";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom/cjs/react-router-dom";
import DefaultProfilePhoto from "../../assets/fallbacks/default-profile-photo.png";
import { Translate, withLocalize } from "react-localize-redux";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";

import LogoutIcon from "../../assets/images/icons/logout-icon.svg";
import { langs } from "../../translations/translateJsonFile";
import SheetFooter from "../sheetFooter/SheetFooter";
import styled from "styled-components";
import { useLayoutEffect } from "react";
import { getMasterConfig } from "wallet-elementkit/dist/constants/master";
import { Subdomains } from "wallet-elementkit/dist/constants";

const StyledMenuSheetWeb = styled.div`
	${(props) => `
    .customizable-text {
      color: ${props.primaryColor} !important;
    }
	.customizable-icon {
		fill: ${props.primaryColor} !important;
	}
	.customizable-bg {
		background: ${props.primaryColor + "10"} !important;
	}

	.customizable-divider{
		background: ${props.primaryColor} !important;
	}
	.active {
		.customizable-icon {
			fill: #fff !important;
		}
	}
  `};
`;
const MenuSheetWeb = (props) => {
	useLayoutEffect(() => {
		props.addTranslation(translations);
	}, []);

	const config = getMasterConfig();

	const userWalletsFiltered =
		config.subDomain === Subdomains.bitdefender
			? []
			: props.userMeta.allUserWallets.filter((org) => !org.isActive);
	return (
		<Modal
			size="sm"
			show={props.sheetOpen}
			onHide={props.onClose}
			animation={false}
			dialogClassName="menu-sheet-web"
			backdropClassName="header-modal-backdrop"
		>
			<StyledMenuSheetWeb
				primaryColor={props.config.primaryColor}
				backgroundColor={props.config.primaryColor}
			>
				<Modal.Header className="customizable-bg">
					<Link
						to={
							props.activeLanguage
								? `/${props.activeLanguage.code}/profile/${props.userMeta.user.username}/`
								: `/en/profile/${props.userMeta.user.username}/`
						}
						style={{
							width: "100%",
						}}
						onClick={props.onClose}
					>
						<div className="profile-row ">
							{props.userMeta.user.profile_url ? (
								<img
									src={props.userMeta.user.profile_url}
									className="profile-img"
									alt="User Profile"
									height="80"
									width="80"
									onClick={props.onClose}
								/>
							) : (
								<img
									src={DefaultProfilePhoto}
									className="profile-img"
									alt="Default User Profile"
									height="80"
									width="80"
									onClick={props.onClose}
								/>
							)}
							<div className="profile-info-col">
								<span className="name-text">{props.userMeta.user.name}</span>
								<span className="email-text customizable-text">
									{props.userMeta.user.email}
								</span>
							</div>
						</div>
					</Link>
					<div className="hz-divider customizable-divider" />
					<div className="wallet-container">
						<div className="org-logo-wrapper">
							<img
								src={
									props.userMeta.allUserWallets.filter((org) => org.isActive)[0]
										?.organizationLogo || props.config.logoLink
								}
								className="org-logo"
								alt="org-logo"
							/>
						</div>
						<span className="org-title">
							{props.userMeta.allUserWallets.filter((org) => org.isActive)[0]
								?.organizationName || props.config.organizationName}
						</span>
					</div>
					<div className="hz-divider customizable-divider" />
				</Modal.Header>

				<Modal.Body className="flex-column ai-c">
					<div className="other-wallets">
						{
							// allUserWalletsmap from index 1
							userWalletsFiltered.map((wallet, index) => {
								return (
									<>
										<div
											className="wallet-container"
											key={`wallet-${index}`}
											onClick={() => {
												props.handleWalletSwitch(wallet.domain);
											}}
										>
											<div className="org-logo-wrapper">
												<img
													src={wallet.organizationLogo}
													className="org-logo"
													alt="org-logo"
												/>
											</div>
											<span className="org-title">
												{wallet.organizationName}
											</span>
										</div>
										<div className="hz-divider " />
									</>
								);
							})
						}
					</div>

					{config.subDomain !== Subdomains.bitdefender && (
						<Dropdown
							id="dropdown-basic-button"
							drop="down"
							align={{ lg: "start" }}
							style={{
								width: "100%",
								zIndex: 9,
								marginTop: "20px",
							}}
							onSelect={(langCode) => {
								props.changeLang(langCode);
							}}
						>
							<Dropdown.Toggle>
								<BaseButton
									type="secondary"
									size="small"
									loading={false}
									width={290}
								>
									<span>
										{props.activeLanguage ? props.activeLanguage.name : ""}
									</span>
								</BaseButton>
							</Dropdown.Toggle>
							<Dropdown.Menu>
								{langs.certificateLanguages.map((language) => (
									<Dropdown.Item eventKey={language.code} key={language.code}>
										{language.name}
									</Dropdown.Item>
								))}
							</Dropdown.Menu>
						</Dropdown>
					)}
					<div className="sheet-sized-box" />
					{
						// For Testing Purposes
						/* <BaseButton
						type="primary"
						size="small"
						width={200}
						loading={false}
						onClickAction={() => {
							console.log("window.location", window.location);
							props.handleWalletSwitch(
								// current pathname
								window.location.origin
							);
						}}
					>
						<Translate id="switch" />
					</BaseButton> */
					}
					<BaseButton
						type="danger"
						size="small"
						width={290}
						loading={false}
						onClickAction={props.logout}
					>
						<img
							src={LogoutIcon}
							alt="Verified Logout"
							style={{ marginRight: "10px" }}
						/>
						<Translate id="logout" />
					</BaseButton>
				</Modal.Body>
				{config.subDomain !== Subdomains.bitdefender && (
					<Modal.Footer>
						<SheetFooter />
					</Modal.Footer>
				)}
			</StyledMenuSheetWeb>
		</Modal>
	);
};

export default withLocalize(MenuSheetWeb);
